import { IberiaCardsCampaign } from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsCampaign';

export class CampaignValidityMap {
  // Local calendar day as YYYY-MM-DD. Deliberately not toISOString(), which converts to UTC
  // and would roll the day over for anyone ahead of UTC late in the evening.
  public static toIsoDate(date: Date): string {
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  // Both bounds are inclusive, and an absent bound means "open on that side".
  // ISO dates compare correctly as plain strings, so this needs no date arithmetic
  // and cannot drift by a day across timezones or DST.
  public static isActive(campaign: IberiaCardsCampaign, todayIsoDate: string): boolean {
    if (campaign.validFrom && todayIsoDate < campaign.validFrom) {
      return false;
    }
    if (campaign.validTo && todayIsoDate > campaign.validTo) {
      return false;
    }
    return true;
  }

  public static filterActive(campaigns: IberiaCardsCampaign[], todayIsoDate: string): IberiaCardsCampaign[] {
    return campaigns.filter((campaign) => CampaignValidityMap.isActive(campaign, todayIsoDate));
  }
}
